import { Transaction } from "@codemirror/state";
import type { EditorView } from "@codemirror/view";

export function clearCode(view: EditorView) {
	const to = view.state.doc.length;
	view.dispatch({
		changes: { from: 0, to, insert: "" },
		annotations: Transaction.addToHistory.of(false),
	});
	view.contentDOM.focus();
}

export function updateCode(
	view: EditorView,
	code: string,
	{ asUserInput = true }: { asUserInput?: boolean } = {},
) {
	const to = view.state.doc.length;
	const updateCode = {
		changes: {
			from: 0,
			to,
			insert: code,
		},
		// stack loads must not look like typing (they'd be written back into the
		// currently keyed stack atom and mark the editor dirty), and they must
		// not be undoable into the previous stack's content
		annotations: asUserInput
			? Transaction.userEvent.of("input")
			: Transaction.addToHistory.of(false),
	};
	view.contentDOM.focus();
	view.dispatch(updateCode);
}
